import React, { useEffect, useState } from 'react'
import { Box, Chip } from '@material-ui/core'
import { connect } from 'react-redux'
import { ErrorOutline } from '@material-ui/icons'
import { Skeleton } from '@material-ui/lab'

import { selectUserTeam } from '../../../redux/selectors/userTeamSelectors'
import {
  loadTeamSubscriptionStart,
  subscribeStart,
  unsubscribeStart,
} from '../../../redux/modules/teamAddOns'
import LinkButton from '../../common/LinkButton'
import { selectDefaultTeamPaymentMethod, selectTeam } from '../../../redux/selectors/teamSelectors'
import { isSubscribed, isSubscriptionCanceled } from './addOnsUtils'
import DialogTeamSubscription from './DialogTeamSubscription'
import ListItemPerk from './ListItemPerk'
import SwitchOnOff from './SwitchOnOff'
import { isEmpty } from 'lodash'

const CanceledActions = ({ endDate, onReactivate }) => {
  return (
    <>
      <Chip label={`Set to deactivate on ${endDate}`} icon={<ErrorOutline />} color="primary" />
      <Box ml={2} display="inline">
        <LinkButton color="primary" onClick={onReactivate}>
          Reactivate
        </LinkButton>
      </Box>
    </>
  )
}

const AddOnSubscription = ({
  userTeam,
  teamSubscription,
  defaultPaymentMethod,
  adminTeam,
  isLoadingSubscription,
  isUpdatingSubscription,
  successUpdatingSubscription,
  loadTeamSubscriptionStart,
  subscribeStart,
  unsubscribeStart,
}) => {
  const [showSubscriptionDialog, setShowSubscriptionDialog] = useState(false)
  const { accountId, totalMembers } = userTeam?.team
  const subscribed = isSubscribed(teamSubscription)
  const canceled = isSubscriptionCanceled(teamSubscription)
  const subscribe = (subscribed && canceled) || !subscribed
  const checked = showSubscriptionDialog ? subscribe : subscribed

  useEffect(() => {
    loadTeamSubscriptionStart(accountId)
  }, [accountId, loadTeamSubscriptionStart])

  useEffect(() => {
    if (successUpdatingSubscription) {
      setShowSubscriptionDialog(false)
      loadTeamSubscriptionStart(accountId)
    }
  }, [accountId, loadTeamSubscriptionStart, successUpdatingSubscription])

  const handleSubmit = () => {
    if (subscribe) {
      // subscribe
      subscribeStart()

      return
    }

    // unsubscribe
    unsubscribeStart()
  }

  const handleOpenSubscriptionDialog = () => {
    setShowSubscriptionDialog(true)
  }

  if (isLoadingSubscription) return <Skeleton variant="rect" height="120px" />

  return (
    <>
      <ListItemPerk
        primaryText="No Delivery Fees"
        secondaryText="Help your team members save money by reducing the delivery fee to $0 for every
                order."
        ChipComponent={<Chip label="$5.99 / MEMBER / MO." />}
        BottomComponent={
          canceled && (
            <CanceledActions
              endDate={teamSubscription.endDate}
              onReactivate={handleOpenSubscriptionDialog}
            />
          )
        }
        ActionComponent={
          <SwitchOnOff
            checked={checked}
            disabled={canceled}
            onClick={handleOpenSubscriptionDialog}
          />
        }
      />

      {showSubscriptionDialog && (
        <DialogTeamSubscription
          teamId={accountId}
          hasDefaultPaymentMethod={!isEmpty(defaultPaymentMethod)}
          teamPaymentCollectionMethod={adminTeam.paymentCollectionMethod}
          subscribe={subscribe}
          canceled={canceled}
          totalMembers={totalMembers}
          isUpdatingSubscription={isUpdatingSubscription}
          onSubmit={handleSubmit}
          onClose={() => setShowSubscriptionDialog(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = state => {
  return {
    userTeam: selectUserTeam(state),
    teamSubscription: state.teamAddOns.teamSubscription,
    defaultPaymentMethod: selectDefaultTeamPaymentMethod(state),
    adminTeam: selectTeam(state),
    isLoadingSubscription: state.teamAddOns.isLoadingSubscription,
    isUpdatingSubscription: state.teamAddOns.isUpdatingSubscription,
    successUpdatingSubscription: state.teamAddOns.successUpdatingSubscription,
  }
}

const mapDispatchToProps = {
  loadTeamSubscriptionStart,
  subscribeStart,
  unsubscribeStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddOnSubscription)
